import { Box } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { useAPIResource, useConfirm } from "@/hooks"
import type { TUser } from "@/types/common"
import { userAPI } from "@/utils"
import { UserLine } from "./UserLine"

interface IProps {
  user: TUser
  children: React.ReactNode
}

export function UserDelete({ user, children }: IProps) {
  const { remove } = useAPIResource(userAPI)
  const { t } = useTranslation()
  const confirm = useConfirm({
    title: t("Do you want to remove this employee?"),
    children: <UserLine user={user} />,
    confirmProps: {
      color: "red",
      children: t("Delete"),
    },
  })
  return (
    <Box
      onClick={async () => {
        if (await confirm()) remove(user.id)
      }}
    >
      {children}
    </Box>
  )
}
